import { START, STOP } from "./actionType"

export const stopButtonAction=()=>{
return {type:STOP}
}
export const startButtonAction=()=>{
return {type:START}
}